import React from "react";
import { Button, Label, Modal, Table } from "semantic-ui-react";
import { socket } from "../../../lib/socketio";
import { getTimestamp } from "../../../lib/time";
import { useSelector } from "react-redux";

function ActiveEventsTable({
  currentPLC,
  data,
  tableData,
  setTableData,
  fetchEvents,
}) {
  // [UPDATE] PP Operation event log, 250703
  // update SOFC 240403 by sumin, get currentPLC data from EventHistory.js
  const [tags, settags] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  // const [tableData, setTableData] = React.useState([]);
  const timezone = useSelector((state) => state.nav.timezone);

  // React.useEffect(() => {
  //     fetchEvents();
  //     return () => {
  //         socket.removeAllListeners();
  //     };
  // }, []);

  // const fetchEvents = () => {
  //     var eventdata =   {'buttonClickType': 'Get Active Events'};
  //     socket.emit('button click', eventdata);
  //     socket.on('receive active events', (data) => {
  //         setTableData(data.result);
  //     });
  // }

  // update SOFC 240403 by sumin, add condition - display each PSM's event log
  const renderBodyRow = (data, index) =>
    data.alarm_name.startsWith(currentPLC)
      ? {
          key: index,
          cells: [
            {
              key: "event_time",
              content: getTimestamp(
                data.datetime,
                timezone,
                data.flag_event_time_ambiguous,
              ),
            },
            {
              key: "event",
              content: parseEventCell(data),
              style: styles.event,
            },
            {
              key: "active",
              content:
                data.active === true
                  ? parseActiveCell("Active")
                  : parseActiveCell("Inactive"),
            },
          ],
        }
      : "";

  return (
    <div>
      <div style={styles.head}>
        <h3>CURRENT ACTIVE EVENTS</h3>
        <Button
          inverted
          color={"green"}
          size="small"
          id="1"
          content="Refresh"
          onClick={fetchEvents}
          style={{ marginLeft: "auto", marginBottom: "5px" }}
        />
      </div>

      <div style={styles.defaults}>
        <Table
          inverted
          unstackable
          compact
          headerRow={POWERPLANT_ALARM_TABLE_HEADER_ROW}
          tableData={tableData}
          renderBodyRow={renderBodyRow}
        />
        {/* <Table inverted unstackable compact>
                    <Table.Header style={styles.thead}>
                        <Table.Row>
                            {POWERPLANT_ALARM_TABLE_HEADER_ROW.map(header => (
                                <Table.HeaderCell key={header.key} style={styles.thTd}>
                                    {header.content}
                                </Table.HeaderCell>
                            ))}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {tableData.map(data => (
                            <Table.Row key={data.id} style = {styles.tbody}>
                                {renderBodyRow(data).cells.map(cell => (
                                    <Table.Cell key={cell.key}>
                                        {cell.content}
                                    </Table.Cell>
                                ))}
                            </Table.Row>
                        ))}
                    </Table.Body>

                </Table> */}
      </div>
    </div>
  );
}

// TODO 250609 PP Operation current active events : head 추가 -> table header 고정용 thead도 추가 해두긴 함,,
const styles = {
  event: {
    padding: "0",
  },
  defaults: {
    alignItems: "center",
    height: "350px",
    overflow: "auto",
    display: "block",
    overflowY: "auto",
  },
  head: {
    display: "flex",
  },
  thead: {
    display: "block",
    position: "sticky",
    top: "0",
    zIndex: "1",
  },
  tbody: {
    display: "block",
    maxHeight: "300px",
    overflowY: "auto",
    width: "100%",
  },
};

const POWERPLANT_ALARM_TABLE_HEADER_ROW = [
  { key: "date", content: "Date", width: 6 },
  { key: "event", content: "Event", width: 6 },
  { key: "active", content: "Current Status", width: 3 },
];

// [TESTLIST] PP Operation event log, change font custom
const parseEventCell = ({ level_id, alarm_name }) =>
  alarm_name.includes("_SD_") ? (
    <div style={{ color: "#FF3333", fontWeight: "bold" }}> {alarm_name}</div>
  ) : (
    <div> {alarm_name} </div>
  );

const parseActiveCell = (active) => (
  <div>
    <Label
      horizontal
      size="medium"
      content={active}
      color={active === "Active" ? "green" : "gray"}
    />
  </div>
);

export default ActiveEventsTable;
